// extracted by mini-css-extract-plugin
export default {"ImageContainer":"ProductImage_ImageContainer__zAckJ","Caption":"ProductImage_Caption__LW71N"};